import { render } from "./candidate-button.vue?vue&type=template&id=776550e7&scoped=true"
import script from "./candidate-button.vue?vue&type=script&lang=js"
export * from "./candidate-button.vue?vue&type=script&lang=js"

import "./candidate-button.vue?vue&type=style&index=0&id=776550e7&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776550e7"]])

export default __exports__